import {
  type PortfolioMockProject,
  type PortfolioMockStage,
} from "./usePortfolioDbStorage"

export const statusColorMap: Record<PortfolioMockStage["status"], string> = {
  complete: "green",
  in_progress: "blue",
  not_started: "default",
  review: "orange",
  has_feedback: "red",
}

export const PORTFOLIO_CATEGORY_LIMITS = {
  selected: 5,
  sustained: 15,
} as const

export const categoryLabelMap: Record<
  PortfolioMockProject["category"],
  string
> = {
  selected: "Selected Work",
  sustained: "Sustained Investigation",
  paused: "Paused",
  unassigned: "Unassigned",
}

export const categoryColorMap: Record<
  PortfolioMockProject["category"],
  string
> = {
  selected: "cyan",
  sustained: "purple",
  paused: "default",
  unassigned: "default",
}

export const categoryTextColorMap: Record<
  PortfolioMockProject["category"],
  string
> = {
  selected: "#08979c",
  sustained: "#722ed1",
  paused: "#8c8c8c",
  unassigned: "#8c8c8c",
}
